// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3bIDh","imageUploader":"EGiftCard_imageUploader__h-FRZ"};